<!-- @TODO Alex/Vik: Think how to avoid template copypast -->
<mat-form-field [class]="inputClass">
  <mat-label class="with-action align-h-space-between">
    <div>
      {{label}}
      <ng-content select="[slot='tooltip']"></ng-content>
    </div>

    @if (canManage) {
      <button
        appStopPropagation
        type="button"
        class="btn link"
        (click)="openManageDialog()">
        Manage Custom
      </button>
    }
  </mat-label>

  <input #searchInput
    matInput
    [errorStateMatcher]="errorStateMatcher"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [matAutocompletePosition]="matAutocompletePosition"
    type="text"
    (input)="onInput($event.target.value)"
    [disabled]="disabled"
    (blur)="onTouched()">

    <mat-autocomplete #auto="matAutocomplete"
      [displayWith]="displayFn"
      (optionSelected)="onSelect($event.option.value)">

      @if (filteredOptions.length) {
        <!-- Group mode -->
        @if (groupBy) {
          @for (groupName of sortedKeys; track groupName) {
            <mat-optgroup [label]="groupName">
              @for (option of groupedOptions.get(groupName); track option) {
                <mat-option [value]="option">
                  {{option.name}}
                </mat-option>
              }
            </mat-optgroup>
          }
        }
        <!-- List mode -->
        @if (!groupBy) {
          @for (option of filteredOptions; track option) {
            <mat-option [value]="option">
              {{option.name}}
            </mat-option>
          }
        }
      }

      <!-- Empty list -->
      @if (searchInput.value.length >= minSearchLength && !filteredOptions.length) {
        <mat-option [disabled]="true">
          No results found
        </mat-option>
      }

    </mat-autocomplete>

    <div matSuffix>
      @if (isLoading) {
        <app-preloader [type]="preloaderTypes.ICON" [size]="20"></app-preloader>
      }
    </div>

    <!-- Show control errors -->
    <mat-error>
      <app-validation-error [errors]="ngControl.errors"></app-validation-error>
    </mat-error>
  </mat-form-field>
